// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import infiniteScroll from "./infiniteScroll";
import indexOverlay from "./indexOverlay";
import headerScroll from "./headerScroll";
import heroVideo from "./heroVideo";
import lightbox from "./lightbox";
import photoGrid from "./photoGrid";
import search from "./search";
import sidenotes from "./sidenotes";
import showsLedger from "./showsLedger";
import storeCatalog from "./storeCatalog";
// menuOpen (the old .gh-burger mobile nav toggle) is no longer used --
// the Index button/overlay replaces it, on both mobile and desktop.


// sidenotes() rewrites [[N]] footnote markers into sidenote markup
// before lightbox() scans the content, so run it first. showsLedger()
// and storeCatalog() similarly rewrite their own page's content
// before anything else looks at it.
sidenotes();
showsLedger();
storeCatalog();
infiniteScroll();
indexOverlay();
headerScroll();
heroVideo();
lightbox();
photoGrid();
search();